import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { LANGUAGE_SELECT } from 'constant/constant';
import { getBrowserLocale, loadTranslationFile } from 'hooks/use-language-select';
import { getTranslationCache } from 'utils/translation-loader';
// to sync locale state across the app since we have multiple react-intl providers in different roots
export const LocaleIntlProvider = ({ children, // Empty-string translations are intentional in this codebase (e.g. automation
// field labels that are visually suppressed in some locales). react-intl's
// default (`fallbackOnEmptyString: true`) treats `""` as a missing translation
// and emits MISSING_TRANSLATION plus falls back to the id, which surfaces as
// the raw key in the UI. Default to `false` app-wide; individual roots can
// still opt back in by passing the prop explicitly.
fallbackOnEmptyString = false, defaultLocale = 'en' })=>{
    const locale = (typeof window !== 'undefined' ? localStorage.getItem(LANGUAGE_SELECT) : null) || getBrowserLocale() || defaultLocale;
    // Initialize with cached English to prevent empty translations during initial render
    const [messages, setMessages] = useState(()=>getTranslationCache().get('en') || {});
    useEffect(()=>{
        loadTranslationFile(locale, true).then(setMessages);
    }, [
        locale
    ]);
    return /*#__PURE__*/ _jsx(IntlProvider, {
        locale: locale,
        messages: messages,
        defaultLocale: defaultLocale,
        fallbackOnEmptyString: fallbackOnEmptyString,
        children: children
    });
};
